import { gql } from '@apollo/client';

export const PREVIEW_CONTACTS_CSV = gql`
    query PreviewContactsCsv($input: PreviewContactsCsvInput!) {
        previewContactsCsv(input: $input) {
            headers
            rowCount
            suggestedMapping {
                csvHeader
                target
            }
        }
    }
`;
